import type { DefaultBlockStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Homepage/constants";
import { useEmailThemeStore } from "../../../Design/useEmailThemeStore";

export const defaultStyles: DefaultBlockStyles = {
  backgroundColor:
    useEmailThemeStore.getState().defaultThemeVariables.light[
      "theme-email-color-background-primary"
    ],
  padding: {
    paddingTop: "64",
    paddingBottom: "64",
    paddingLeft: "32",
    paddingRight: "32",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};
